<template>
    <div>
        <work-history-item   v-for="(workHistoryData, i) in workHistoriesData" :key="i" :workHistoryData="workHistoryData"/> 
    </div>
</template>

<script>
import WorkHistoryItem from "./items/WorkHistoryItem.vue";
export default {
    name: "WorkHistories",
    props: {
        workHistoriesData: {
            type: Array,
            required: true
        }
    },
    components: {
        WorkHistoryItem
    },
  
}
</script>

<style>

</style>